import React, { useState, useEffect } from "react";
import Logo from "../../../assets/image/jas-logo-wb.png";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

function SuperAdminAreaLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showOTPField, setShowOTPField] = useState(false);
  const [exhibitorLoginActive, setExhibitorLoginActive] = useState(true);

  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const userType = pathname.split("/")[1];
  console.log("helllo i am here ", capitalizeFirstLetter(userType));
  localStorage.setItem(
    "exhibitor_agent_type",
    capitalizeFirstLetter(userType)
  );

  const exhibitorAgentType = localStorage.getItem("exhibitor_agent_type");


  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleChange();
    }
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data && res.data.data && res.data.data.exhibitor_login === "inactive") {
          setExhibitorLoginActive(false);
        }
      })
      .catch((err) => console.log(err));

    const token = localStorage.getItem("jff_token");
    if (token && token !== "undefined") {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-authenticity/${token}`
        )
        .then((resData) => {
          if (
            resData.data.status &&
            resData.data.permission_names.includes("exhibitor")
          ) {
            navigate(`/${exhibitorAgentType.toLowerCase()}/dashboard`);
          }
          // If the token is valid but NOT for an exhibitor, we just stay on the login page
          // so the user can log in as an exhibitor.
        })
        .catch(() => {});
    } else {
      localStorage.removeItem("jff_token");
    }
  }, []);

  const handleChange = async () => {
    setIsLoading(true);
    if (!email) {
      message.error("Enter username or email");
      setIsLoading(false);
      return;
    }

    if (!password) {
      const response = await axios.post(`${process.env.REACT_APP_API_END_POINT}/generate-otp`, {
        email,
      })

      console.log('Response: ', response);
      if (response?.data?.success) {
        setShowOTPField(true);
      } else {
        message.error(response?.data?.message);
      }

      setIsLoading(false);
      return;
    } else {
      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/login`, {
          email,
          password,
          login_type: "exhibitor",
        })
        .then((response) => {
          // If login was denied (no token returned), show error and stop
          if (!response.data.token) {
            setIsLoading(false);
            message.error(response.data.message || "Invalid credentials");
            return;
          }

          // insert token in localstorage
          localStorage.setItem(
            "permission",
            JSON.stringify(response.data.category.permissions)
          );
          localStorage.setItem("jff_token", response.data.token);
          localStorage.setItem("user_id", response.data.category._id);
          localStorage.setItem(
            "type_of_user",
            `/${exhibitorAgentType.toLowerCase()}/login`
          );

          let data = response.data.category.permissions;
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/get-permission-name`,
              {
                permission: data,
              }
            )
            .then((res) => {
              setIsLoading(false);
              let nameArray = res.data.data;

              if (nameArray.includes("exhibitor")) {
                navigate(`/${exhibitorAgentType.toLowerCase()}/dashboard`);
              } else {
                message.error("Access Denied");
              }
            })
            .catch((err) => {
              setIsLoading(false);
              message.error("An error occurred while fetching permissions");
            });
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          message.error("Login failed. Please check your credentials.");
        });
    }
  };

  if (!exhibitorLoginActive) {
    return (
      <div className="container">
        <img
          src={Logo}
          alt="logo-img"
          className="my-1 mx-auto d-flex"
          style={{ height: "200px", width: "auto", background: "#b98b51", padding: "10px", borderRadius: "10px" }}
        />

        <div className="exhibitorlogin">
          <div className="exhibitorloginbody text-center py-5">
            <h2 className="mb-4 fw-bold" style={{ color: '#8a6d3b' }}>Portal is Closed</h2>
            <p className="text-muted mb-4">Please contact +91 8619192820 for further assistance.</p>
          </div>
        </div>
        <div className="text-center">
          <button className="btn btn-sm" style={{ backgroundColor: "#221f1c", color: "white" }} onClick={() => (window.location.href = "https://jasjaipur.com/")}>Go Back to JAS-Jaipur</button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container">
        <img
          src={Logo}
          alt="logo-img"
          className="my-1 mx-auto d-flex"
          style={{ height: "200px", width: "auto", background: "#b98b51", padding: "10px", borderRadius: "10px" }}
        />

        <div className="exhibitorlogin">
          <div className="exhibitorloginbody">
            <div className="fw-semi-bold fs-3">
              Welcome to {localStorage.getItem('exhibitor_agent_type')} login
            </div>
            <Form className="my-4" onSubmit={(e) => e.preventDefault()}>
              <Form.Control
                type="username"
                placeholder="Enter Phone Number"
                className="my-4"
                onChange={(e) => setEmail(e.target.value)}
                required
                onKeyDown={handleKeyDown}
              />

              {showOTPField &&
                <Form.Control
                  type="password"
                  id="inputPassword5"
                  aria-describedby="passwordHelpBlock"
                  placeholder="Enter OTP"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  onKeyDown={handleKeyDown}
                />
              }

              <Button className="my-4 btn-block" onClick={handleChange}>
                {isLoading ? <Spinner animation="border" size="sm" /> : "Login"}
              </Button>
            </Form>

            <h6 style={{ color: 'white !important' }}><b>Note:</b> For any queries and questions, Please contact to the given number - 8619192820</h6>

          </div>
        </div>
        <           div className="text-center">
          <button className="btn btn-sm" style={{ backgroundColor: "#221f1c", color: "white" }} onClick={() => (window.location.href = "https://jasjaipur.com/")}>Go Back to JAS-Jaipur</button>
        </div>
      </div>
    </>
  );
}

export default SuperAdminAreaLogin;
